
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
export default {
  components: {},
  setup() {
    const isActive = ref("");
    const store = useStore();
    const auth_user = computed(() => store.state.AuthUser.user);

    return {
      isActive,
      auth_user,
    };
  },
};
